import SwaggerClient from 'swagger-client'
import * as subSystemUtil from "./utils/subSystem";
import store from "./store";
import * as subSystem from './utils/subSystem';
import * as system from './utils/system';
import dayjs from 'dayjs';

export default {
  methods: {
    /////////////////////////////////////
    //
    // SwaggerClient取得処理
    //
    ////////////////////////////////////
    getSwaggerClient: function (bodyJson, subSystem) {
      if (!subSystem) {
        subSystem = subSystemUtil.SUB_SYSTEMS.breath;
      }

      let subSystemKeyName = "";
      let url = '/api-docs';
      if (subSystem.id != subSystemUtil.SUB_SYSTEMS.breath.id) {
        subSystemKeyName = subSystem.keyName;
        url += '/' + subSystemKeyName;
      }

      var ret = null;
      if (bodyJson) {
        const waggerClientForJson = "waggerClientForJson" + subSystemKeyName;
        if (!window[waggerClientForJson]) {
          window[waggerClientForJson] = new SwaggerClient({
            url: url,
            requestInterceptor: req => {
              if (req.body) {
                req.headers['Content-Type'] = 'application/json'
              }
              //↓モックの場合は、以下をコメントアウトすること
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            },
            responseInterceptor: res => {
              console.log(res)
            }
          })
        }
        ret = window[waggerClientForJson]
      } else {
        const waggerClient = "waggerClient" + subSystemKeyName;
        if (!window[waggerClient]) {
          window[waggerClient] = new SwaggerClient({
            url: url,
            requestInterceptor: req => {
              //↓モックの場合は、以下をコメントアウトすること
              req.headers['Authorization'] = JSON.parse(sessionStorage.getItem('userInfo')).token
            },
            responseInterceptor: res => {
              console.log(res)
            }
          })
        }
        ret = window[waggerClient]
      }
      return ret;
    },
    /////////////////////////////////////
    //
    // WebAPI実行関数
    //
    ////////////////////////////////////
    /**
     * Web API を実行します。
     * @param {*} executeApi 実行するWebAPIのメソッド
     * @param {*} successCallback 成功時のコールバック関数
     * @param {*} errorCallback 　エラー時のコールバック関数
     */
    apiCall: function (executeApi, successCallback, errorCallback, subSystem) {
      return this.callApi(true, executeApi, successCallback, errorCallback, subSystem)
    },
    /**
     * Web API を実行します。(ファイルアップロード系API)
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     */
    uploadApiCall: function (executeApi, successCallback, errorCallback, subSystem) {
      return this.callApi(false, executeApi, successCallback, errorCallback, subSystem)
    },
    /**
     * Web API を実行します。(ファイルダウンロード系API)
     * @param {*} executeApi 
     * @param {*} errorCallback 
     */
    downloadApiCall: function (executeApi, errorCallback, subSystem, expSuccessCallback) {
      var successCallback = (result) => {
        console.log(result)
        var name = result.headers['content-disposition'].split('=')[1]
        name = name.slice(name.lastIndexOf('\'') + 1)


        const blob = result.data
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = decodeURI(name)
        link.click()

        if (expSuccessCallback) {
          expSuccessCallback(result);
        }
      }
      return this.callApi(true, executeApi, successCallback, errorCallback, subSystem)
    },

    /**
     * Web API を実行します。(S3からのファイルダウンロード系API)
     * @param {*} executeApi 
     * @param {*} errorCallback 
     */
    downloadS3ApiCall: function (executeApi, errorCallback, subSystem) {
      let successCallback = (result) => {
        console.log(result);
        if (result != null && result.status == 200) {
          let downloadUrl = result.obj.downloadUrl;
          const a = document.createElement("a");
          a.href = downloadUrl;
          a.download = decodeURI(result.obj.fileName);
          a.click();
          a.remove();
        }
      }
      return this.callApi(true, executeApi, successCallback, errorCallback, subSystem);
    },

    /**
     * Web API を実行します。（内部呼出しのみ！）
     * @param {*} bodyJson 
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     */
    callApi: function (bodyJson, executeApi, successCallback, errorCallback, subSystem) {
      var appVue = this.$root.$children[0]  //TODO App.vueの取得方法はこれで合っているか？
      var loadingFlag = true
      // ロード中か判定
      if (appVue.$data.isLoading) {
        loadingFlag = false
      }

      if (loadingFlag) {
        appVue.loadingStart()
      }

      return new Promise(resolve => {
        this.getSwaggerClient(bodyJson, subSystem)
          .then(client => {
            // WebAPI Call
            return executeApi(client)
          }).then(result => {
            console.log(result)
            if (loadingFlag) {
              appVue.loadingEnd()
            }

            // WebAPI応答内容を画面に設定
            successCallback(result)
            resolve()
          }).catch(error => {
            console.log(error)
            if (error != null) {
              // サーバから返されたメッセージをダイアログ表示
              var message = ''
              if (!error.status) {
                message = error.message
              } else if (error.status === 403) {
                message = "トークンが不正またはタイムアウトしています。再ログインしてください。"
              }
              else if (error.response.body) {
                if (error.response.body.message) {
                  message = error.response.body.message
                } else {
                  message = error.message
                }
              } else {
                message = error.message
              }
              if (loadingFlag) {
                appVue.loadingEnd()
              }
              errorCallback(message)
              console.log(message)
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              errorCallback('予期しないエラーが発生しました。')
              if (loadingFlag) {
                appVue.loadingEnd()
              }
            }
            resolve()
          })
      }).catch(error => {
        console.log(error)
        this.$root.$children[0].loadintEnd()
        errorCallback('予期しないエラーが発生しました。')
        resolve()
      })
    },
    /**
     * API成功時のダイアログメッセージを表示します。
     * @param {*} result 
     */
    showSuccess: function (result) {
      var resBody = result.obj
      var messageStr = resBody['message']
      if (messageStr.indexOf("\n")) {
        var resultList = messageStr.split("\n");
        for (var i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      this.$dialog.alert({
        title: '　',
        message: messageStr,
      })
    },
    /**
     * API失敗時のダイアログメッセージを表示します。
     * @param {*} messageStr 
     */
    showErrorMessage: async function (messageStr) {
      if (messageStr.indexOf("\n")) {
        var resultList = messageStr.split("\n");
        for (var i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      await this.$dialog.alert({
        title: '　',
        message: messageStr,
      })
    },
    /**
     * 警告ダイアログを表示します。
     * @param {*} messageStr 
     */
    showComfirmMessage: async function (messageStr) {
      if (messageStr.indexOf("\n")) {
        const resultList = messageStr.split("\n");
        for (let i = 0; i < resultList.length; i++) {
          if (i != 0) {
            messageStr = messageStr + "<br>" + resultList[i];
          } else {
            messageStr = resultList[i];
          }
        }
      }
      const res = await new Promise((resoleve, reject) => {
        this.$dialog.confirm({
          title: "　",
          message: messageStr,
          onConfirm: () => {
            resoleve();
          },
          onCancel: () => {
            reject();
          }
        });
      }).then(() => {
        return true;
      }).catch(() => {
        return false;
      });

      return await res;
    },
    /**
     * 2Gを超えるファイルが存在するかどうかのチェック
     */
    checkUploadFileSize: async function (uploadItemInfoList) {
      const MAX_NODE_BUFFER_SIZE = 2147000000;
      let ret = true;
      for (let uploadItemIfno of uploadItemInfoList) {
        let uploadItem = uploadItemIfno.file;
        const traverseFileTree = async (entry, path) => {
          const _path = path || "";
          if (entry instanceof File) {
            if (entry.size > MAX_NODE_BUFFER_SIZE) {
              ret = false;
            }
          } else if (entry.isFile) {
            const file = await new Promise((resolve) => {
              entry.file((file) => {
                resolve(file);
              });
            });
            if (file.size > MAX_NODE_BUFFER_SIZE) {
              ret = false;
            }
          }
        };
        // ここでドロップされた最初のファイルを渡す
        await traverseFileTree(uploadItem);
      }
      return ret;
    },
    /**
     * 
     * @param {*} bodyJson 
     * @param {*} executeApi 
     * @param {*} successCallback 
     * @param {*} errorCallback 
     * @param {*} doLoading 
     * @returns 
     */
    multipleUpload: async function (uploadItemInfoList, subSystem, errorCallback) {
      let successUploadFiles = [];
      let appVue = this.$root.$children[0];
      if (uploadItemInfoList.length < 1) {
        return Promise.resolve(successUploadFiles);
      }
      appVue.loadingStart();
      try {
        let identifier = new Date().getTime();
        let uploadFileList = [];
        //ファイルを抽出
        for (let uploadItemIfno of uploadItemInfoList) {
          if (!uploadItemIfno.file) {
            // 既存添付は送信対象外
            continue;
          }
          let uploadItem = uploadItemIfno.file;

          // ファイルスキャン関数
          const traverseFileTree = async (entry, path) => {
            const _path = path || "";
            if (entry instanceof File) {
              // ファイルを取得したらリストにプッシュする
              uploadFileList.push({ file: entry, path: _path + entry.name, fileName: entry.name });
            }
            else if (entry.isFile) {
              const file = await new Promise((resolve) => {
                entry.file((file) => {
                  resolve(file);
                });
              });
              // ファイルを取得したらリストにプッシュする
              uploadFileList.push({ file: file, path: _path + file.name });
            }
          };

          // ここでドロップされた最初のファイルを渡す
          await traverseFileTree(uploadItem);
        }
        if (uploadFileList.length < 1) {
          return Promise.resolve(successUploadFiles);
        }
        try {
          //アップロードトランザクション開始
          let uploadId = 0;
          await this.callApi(
            true,
            function (client) {
              return client.apis.apiCommon.uploadFilePollingStartPOST();
            },
            function (result) {
              uploadId = result.obj.id;
            },
            function (error) {
              throw error;
            },
            subSystem
          );

          let roop = true;
          for (let i = 0; i < uploadFileList.length; i++) {
            if (roop == false) {
              break;
            }
            let uploadFile = uploadFileList[i];
            if (i != uploadFileList.length - 1) {
              console.log("file upload.");
              await this.callSyncApi(
                false,
                function (client) {
                  return client.apis.apiCommon.uploadFilePOST({
                    uploadId: uploadId,
                    upfile: uploadFile.file,
                    path: uploadFile.path,
                    identifier: identifier
                  })
                },
                function (result) { },
                function (error) {
                  console.log("file upload. error = " + error);
                  roop = false;
                  errorCallback(error + "\n\n" + uploadFile.fileName);
                },
                subSystem
              );
            } else {
              console.log("file last upload.");
              //最後の1ファイルは非同期で呼び出す。
              await this.callSyncApi(
                false,
                function (client) {
                  return client.apis.apiCommon.uploadLastFilePOST({
                    uploadId: uploadId,
                    upfile: uploadFile.file,
                    path: uploadFile.path,
                    identifier: identifier
                  });
                },
                function (result) {
                  successUploadFiles = result.obj;
                },
                function (error) {
                  console.log("file last upload. error = " + error);
                  roop = false;
                  errorCallback(error + "\n\n" + uploadFile.fileName);
                },
                subSystem
              ).catch(error => {
                throw error;
              });
            }
          }
          //終了状況のチェック(ポーリング)
          let nomalFinished = false;
          const _sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
          while (roop) {
            await _sleep(3000); //3秒毎にチェックする
            if (roop) {
              await this.callApi(
                true,
                function (client) {
                  return client.apis.apiCommon.uploadFilePollingCheckPOST({ body: { id: uploadId } });
                },
                function (result) {
                  if (result.status != 200) {
                    console.log(result.statusText);
                    roop = false;
                  } else {
                    let status = result.obj.status;
                    if (status == "saveLastFileToTmp") {
                      console.log("polling success finish.");
                      roop = false;
                      nomalFinished = true;
                    } else if (status == "error") {
                      console.log("polling error finish.");
                      roop = false;
                    } else {
                      console.log("continue polling..." + new Date().getTime());
                    }
                  }
                },
                function (error) {
                  console.log(error);
                  throw error;
                },
                subSystem
              );
            }
          }
          if (nomalFinished) {
            return Promise.resolve(successUploadFiles);
          } else {
            return Promise.reject("予期しないエラーが発生しました。");
          }
        } catch (e) {
          console.log('error: ', e);
          return Promise.reject(e);
        }
      } finally {
        appVue.loadingEnd();
      }
    },
    callSyncApi: async function (bodyJson, executeApi, successCallback, errorCallback, subSystem) {
      return new Promise(resolve => {
        this.getSwaggerClient(bodyJson, subSystem)
          .then(client => {
            // WebAPI Call
            return executeApi(client);
          }).then(result => {
            console.log(result);
            // WebAPI応答内容を画面に設定
            successCallback(result);
            resolve(0);
          }).catch(error => {
            console.log(error);
            var message = '予期しないエラーが発生しました。';
            if (error != null) {
              // サーバから返されたメッセージをダイアログ表示
              if (!error.status) {
                message = error.message;
              } else if (error.status === 403) {
                // WAFに止められた場合
                switch (error.response.headers.server) {
                  case system.RESPONSE_SERVER.AWS_ELB:
                    errorCallback(
                      "添付ファイルをアップロードできませんでした。\nファイルの内容に問題がある可能性があります。\n再作成して添付してください。"
                    );
                    resolve();
                    return;
                  
                  default:
                    message = "トークンが不正またはタイムアウトしています。再ログインしてください。";
                    break;
                }
              }
              else if (error.response.body) {
                if (error.response.body.message) {
                  message = error.response.body.message;
                } else {
                  message = error.message;
                }
              } else {
                message = error.message;
              }
              errorCallback(message);
              console.log(message);
            } else {
              // "予期しないエラーが発生しました。"でダイアログを表示
              errorCallback('予期しないエラーが発生しました。');
            }
            resolve(message);
          })
      }).catch(error => {
        console.log(error);
        errorCallback(error);
        resolve(error);
      })
    },
    /////////////////////////////////////
    //
    // Date<->String変換関数
    //
    ////////////////////////////////////
    /**
     * yyyy/M/dの文字列を取得します。
     * @param {*} date 
     */
    formatDate: function (date) {
      var ret = "yyyy/M/d"
      ret = ret.replace(/yyyy/g, date.getFullYear())
      ret = ret.replace(/M/g, (date.getMonth() + 1))
      ret = ret.replace(/d/g, (date.getDate()))
      return ret;
    },
    formatDate2: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy/MM/dd"
      ret = ret.replace(/yyyy/g, date.getFullYear())
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      ret = ret.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      return ret;
    },
    formatDate3: function (date) {
      if (!date) {
        return date;
      }
      var ret = "yyyy-MM-dd"
      ret = ret.replace(/yyyy/g, date.getFullYear())
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      ret = ret.replace(/dd/g, ('0' + date.getDate()).slice(-2))
      return ret;
    },
    /**
     * yyyy/M/dの文字列をDateオブジェクトに変換します。
     * @param {*} parseStr (yyyy/M/dの文字列)
     */
    parseDate: function (parseStr) {
      if (!parseStr) {
        return parseStr;
      }
      if (parseStr.match(' ') == -1) {
        var parseStr = parseStr.split('/');
        return new Date(parseStr[0], parseStr[1], parseStr[2])
      }
      return new Date(parseStr)
    },
    /**
     * yyyyMMddの文字列をDateオブジェクトに変換します。
     * @param {*} parseStr (yyyyMMddの文字列)
     */
    parseDate2: function (parseStr) {
      if (!parseStr || parseStr.length < 8) {
        return null;
      }
      var year = parseStr.slice(0, 4)
      var month = parseStr.slice(4, 6)
      var day = parseStr.slice(6, 8)
      return new Date(Number(year), Number(month - 1), Number(day))
    },
    /**
     * yyyy/Mの文字列をDateオブジェクト(yyyy/M/01のDate)に変換します。
     * @param {*} parseStr (yyyy/Mの文字列)
     */
    parseDateMonth: function (parseStr) {
      if (!parseStr) {
        return parseStr;
      }
      parseStr = parseStr + '/01'
      return this.parseDate(parseStr)
    },
    /**
     * yyyy/Mの文字列を取得します
     * @param {*} date 
     */
    formatMonth: function (date) {
      var ret = "yyyy/M"
      ret = ret.replace(/yyyy/g, date.getFullYear())
      ret = ret.replace(/M/g, (date.getMonth() + 1))
      return ret;
    },
    formatMonth2: function (date) {
      var ret = "yyyy/MM"
      ret = ret.replace(/yyyy/g, date.getFullYear())
      ret = ret.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2))
      return ret;
    },
    /**
     * HH：mmの文字列を取得します
     * @param {*} date 
     */
    formatTime: function (date) {
      var ret = "HH:mm"
      var HH = ('0' + date.getHours()).slice(-2)
      var mm = ('0' + date.getMinutes()).slice(-2)
      ret = ret.replace(/HH/g, HH)
      ret = ret.replace(/mm/g, mm)
      return ret;
    },
    /**
     * HH：mmの文字列をDateオブジェクトに変換します。
     * ※Dateの日付は実行日
     * @param {*} parseStr (HH：mmの文字列)
     */
    parseTime: function (parseStr) {
      var str = parseStr.split(':')
      var retDate = new Date()
      str[0] = (0 + str[0]).slice(-2)
      str[1] = (0 + str[1]).slice(-2)
      retDate.setHours(str[0])
      retDate.setMinutes(str[1])
      return retDate
    },
    /**
     * 月初の日付を取得します。（yyyy/M/1）
     * @param {*} date 
     */
    getMonthFirstDay: function (date) {
      date.setDate(1)
      return this.formatDate(new Date(date))
    },
    /**
     * 月末の日付を取得します。（yyyy/M/28,29,30,31）
     * @param {*} date 
     */
    getMonthLastDay: function (date) {
      date.setMonth(date.getMonth() + 1) //翌月
      date.setDate(0)  //前の月の最終日
      return this.formatDate(new Date(date))
    },
    /**
     * 数字の配列をintegerの配列に変換します。
     * ※検索時の複数セレクトフィールドで使用する
     * @param {*} strArray 
     */
    setNumArray: function (strArray) {
      var retArray = []
      for (var i = 0, len = strArray.length; i < len; i++) {
        var str = strArray[i]
        var num = Number(str)
        if (num != 'NaN') {
          retArray.push(num)
        }
      }
      return retArray
    },
    /**
     * 文字列をboolean値に変更します。
     * @param {*} str 
     */
    parseBoolean: function (str) {
      var ret = false
      if (typeof (str) == 'string') {
        str = str.toLowerCase()
        if (str === 'true') {
          ret = true
        }
      }
      return ret;
    },
    /**
     * 文字列から空白を除き、サイズを判定します。
     * @param {*} str 
     * @return true:サイズ1以上, false:サイズ0
     */
    isLength: function (str) {
      var ret = true
      if (typeof (str) == 'string') {
        str = str.replace(/\s/g, "")
        if (str.length == 0) {
          ret = false
        }
      }
      return ret;
    },
    /**
     * 検索条件(可変選択)が全件検索でないかを判定します。
     * @param {*} str 
     * @return true:全件検索対象, false:全件対象でない
     */
    isSearchAll: function () {
      var ret = false
      var trueCnt = 0
      var isNotZero = false;
      for (var i = 0; i < arguments.length; i++) {
        if (arguments[i][0] == arguments[i][1]) {
          trueCnt++
        } else {
          if (arguments[i][0] != 0) {
            isNotZero = true
          }
        }
      }
      if (trueCnt >= 1 && !isNotZero) {
        var ret = true
      }
      return ret;
    },
    /////////////////////////////////////
    //
    // 次回点検日計算ロジック
    //
    ////////////////////////////////////
    /**
     * 次回点検日の算出結果を取得します。
     * @param {*} key
     */
    getNextInspectionDate: function (PRCHD, CTERM, LTDAT, nextMaintenanceDate, leaseUpMachineFlg) {
      // 次回点検予定日
      var month = CTERM * 1;
      var next1InspectionDate = new Date(Number(PRCHD.getFullYear()) + (month / 12), Number(PRCHD.getMonth()) + (month % 12), PRCHD.getDate() + 1)
      next1InspectionDate = this.formatDate2(next1InspectionDate).replace(/\//g, "");
      // 次々回点検予定日
      month = CTERM * 2;
      var next2InspectionDate = new Date(Number(PRCHD.getFullYear()) + (month / 12), Number(PRCHD.getMonth()) + (month % 12), PRCHD.getDate() + 1)
      next2InspectionDate = this.formatDate2(next2InspectionDate).replace(/\//g, "");
      PRCHD = this.formatDate2(PRCHD)
      var schedule
      // 動態表マスタ「nextInspectionDate」に値がない場合は、メンテナンスを対象に含まない。
      var now = this.formatDate2(new Date())
      if (nextMaintenanceDate) {
        if (!leaseUpMachineFlg) {
          schedule = [
            {
              code: 3,
              // リースアップ日が、前回点検日以上かつ、次回定期点検日以前かつ、現在日付より過去日の場合、日付のみ定期点検で表示させる
              date: (LTDAT < now) && (next1InspectionDate >= LTDAT) && (LTDAT >= PRCHD) ? next1InspectionDate : LTDAT
            },
            {
              code: 2,
              // 次回メンテナンス日
              date: nextMaintenanceDate
            },
            {
              code: 1,
              date: next1InspectionDate // 次回点検予定日
            }
          ]
        } else {
          schedule = [
            {
              code: 2,
              // 次回メンテナンス日
              date: nextMaintenanceDate
            },
            {
              code: 1,
              date: next1InspectionDate // 次回点検予定日
            }
          ]
        }
      } else {
        // リースアップ + 機械交換ありの場合 リース日は対象に含まない
        if (!leaseUpMachineFlg) {
          schedule = [
            {
              code: 3,
              // リースアップ日が、前回点検日以上かつ、次回定期点検日以前かつ、現在日付より過去日の場合、日付のみ定期点検で表示させる
              date: (LTDAT < now) && (next1InspectionDate >= LTDAT) && (LTDAT >= PRCHD) ? next1InspectionDate : LTDAT
            },
            {
              code: 1,
              date: next1InspectionDate // 次回点検予定日
            }
          ]
        } else {
          schedule = [
            {
              code: 1,
              date: next1InspectionDate // 次回点検予定日
            }
          ]
        }
      }

      var INSPECTION_DETAIL_TYPE = {
        "INSTALLATION": {
          code: 0,
          value: "設置"
        },
        "THREE_MONTH_INSPECTION": {
          code: 1,
          value: "定期点検"
        },
        "MAINTENANCE": {
          code: 2,
          value: "メンテナンス"
        },
        "LEASEUP": {
          code: 3,
          value: "リースアップ"
        },
        "EMERGENCY": {
          code: 4,
          value: "緊急対応"
        }
      }

      // 前回点検予定日以降から次々回点検予定日までの内、コードの降順(リースアップ/メンテ/点検順)で該当したものを取得
      var find = schedule.find((target) => target.date && PRCHD <= target.date && next2InspectionDate >= target.date);
      if (find) {
        var result = {
          code: find.code,
          value: this.codeToValue(INSPECTION_DETAIL_TYPE, find.code)
        }
        // 日付の昇順でソート 予定が存在しない場合は最大値とみなす
        schedule.sort((a, b) => {
          var compare = 0
          if (a.date && b.date) {
            if (a.date > b.date) {
              compare = 1
            } else if (a.date < b.date) {
              compare = -1
            }
          } else if (a.date) {
            compare = -1
          } else if (b.date) {
            compare = 1
          }

          return compare
        })

        // 前回点検予定日以降から次々回点検予定日までの内、直近の予定日を取得
        var find = schedule.find((target) => target.date && PRCHD <= target.date && next2InspectionDate >= target.date);
        result.date = new Date(find.date.substr(0, 4) + "/" + find.date.substr(4, 2) + "/" + find.date.substr(6, 2))
        return result
      } else {
        return ""
      }
    },
    /**
     * 指定された種別のコード値から、値を取得する。
     */
    codeToValue: function (types, code) {
      var result;
      var find = Object.keys(types).filter(function (type) { return types[type].code == code })[0];
      if (find) {
        result = types[find].value;
      };

      return result;
    },
    /////////////////////////////////////
    //
    // 消耗品用品目一覧取得関数
    //
    ////////////////////////////////////    
    /**
     * 全ての消耗品用品目リストをパラメータのdeliveryListに設定します。
     * deliveryListには以下の構造でデータを設定します。
     * [
     *  {
     *    productCode: productCode,
     *    productName: productName
     *  }
     * ]
     * @param {*} deliveryList
     */
    getDeliveryList: function (deliveryList) {
      var excuteApi = this.getDeliveryProductListPOST
      var successCallBack = function (result) {
        var retDeliveryList = result.obj
        for (var i = 0; i < retDeliveryList.length; i++) {
          var productCode = retDeliveryList[i].productCode
          var productName = retDeliveryList[i].productName
          var productDataKeyCode = {
            key: productCode + ' ' + productName,
            productCode: productCode,
            productName: productName
          }
          deliveryList.push(productDataKeyCode)
        }
        deliveryList.sort(function (a, b) {
          if (a.key > b.key) {
            return 1;
          } else {
            return -1;
          }
        })
      }
      var errorCallBack = this.getDeliveryListPOSTError
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getDeliveryProductListPOST: function (client) {
      return client.apis.apiMaster.getDeliveryProductListPOST({
        body: {}
      })
    },
    getDeliveryListPOSTError: function (result) {
      this.showErrorMessage(result);
    },
    /////////////////////////////////////
    //
    // 品目一覧取得関数
    //
    ////////////////////////////////////    
    /**
     * 全ての品目リストをパラメータのproductListに設定します。
     * productListには以下の構造でデータを設定します。
     * [
     *  {
     *    productCode: productCode,
     *    productName: productName
     *  }
     * ]
     * @param {*} productList
     */
    getProductList: function (productList) {
      var excuteApi = this.getProductListPOST
      var successCallBack = function (result) {
        var retProductList = result.obj
        for (var i = 0, len = retProductList.length; i < len; i++) {
          var productCode = retProductList[i].productCode
          var productName = retProductList[i].productName
          var productDataKeyCode = {
            key: productCode + ' ' + productName,
            productCode: productCode,
            productName: productName
          }
          productList.push(productDataKeyCode)
        }
        productList.sort(function (a, b) {
          if (a.key > b.key) {
            return 1;
          } else {
            return -1;
          }
        })
      }
      var errorCallBack = this.getProductListPOSTError
      // WebAPI Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getProductListPOST: function (client) {
      return client.apis.apiMaster.getProductListPOST({
        body: {}
      })
    },
    getProductListPOSTError: function (result) {
      console.log(result)
    },
    /////////////////////////////////////
    //
    // カナ検索用関数
    //
    //////////////////////////////////// 
    kanaJudg: function (value) {
      if (!value) {
        return true
      }
      var kanaMap = {
        "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
        "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
        "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
        "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
        "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
        "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
        "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
        "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
        "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
        "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
        "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
        "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
        "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
        "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
        "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
        "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
        "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
        "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
        "。": "｡", "、": "､", "ー": "ｰ", "「": "｢", "」": "｣", "・": "･"
      };

      var kanaMap2 = {
        'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
        'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
        'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
        'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
        'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
        'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
        'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
        'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
        'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
        'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
        'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
        'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
        'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
        'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
        'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
        'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
        'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
        'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
        '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
      };

      var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
      var reg2 = new RegExp('(' + Object.keys(kanaMap2).join('|') + ')', 'g');
      var hanKanaCnt = (value.match(reg) || []).length
      var zenKanaCnt = (value.match(reg2) || []).length
      var ret = false
      value = value.replace(/゛/g, '').replace(/゜/g, '').replace(/ﾞ/g, '').replace(/ﾟ/g, '').replace(/ /g, '').replace(/　/g, '')
      if (hanKanaCnt + zenKanaCnt
        == value.length) {
        ret = true
      }
      return ret
    },

    convFullHalfWidthCharacterKana: function (kana, conversionType) {

      if (!kana) {
        return ""
      }
    
      let result = ""
      switch (conversionType) {
        case "full":
          // 全角に変換する場合
          var kanaMap = {
            'ｶﾞ': 'ガ', 'ｷﾞ': 'ギ', 'ｸﾞ': 'グ', 'ｹﾞ': 'ゲ', 'ｺﾞ': 'ゴ',
            'ｻﾞ': 'ザ', 'ｼﾞ': 'ジ', 'ｽﾞ': 'ズ', 'ｾﾞ': 'ゼ', 'ｿﾞ': 'ゾ',
            'ﾀﾞ': 'ダ', 'ﾁﾞ': 'ヂ', 'ﾂﾞ': 'ヅ', 'ﾃﾞ': 'デ', 'ﾄﾞ': 'ド',
            'ﾊﾞ': 'バ', 'ﾋﾞ': 'ビ', 'ﾌﾞ': 'ブ', 'ﾍﾞ': 'ベ', 'ﾎﾞ': 'ボ',
            'ﾊﾟ': 'パ', 'ﾋﾟ': 'ピ', 'ﾌﾟ': 'プ', 'ﾍﾟ': 'ペ', 'ﾎﾟ': 'ポ',
            'ｳﾞ': 'ヴ', 'ﾜﾞ': 'ヷ', 'ｦﾞ': 'ヺ',
            'ｱ': 'ア', 'ｲ': 'イ', 'ｳ': 'ウ', 'ｴ': 'エ', 'ｵ': 'オ',
            'ｶ': 'カ', 'ｷ': 'キ', 'ｸ': 'ク', 'ｹ': 'ケ', 'ｺ': 'コ',
            'ｻ': 'サ', 'ｼ': 'シ', 'ｽ': 'ス', 'ｾ': 'セ', 'ｿ': 'ソ',
            'ﾀ': 'タ', 'ﾁ': 'チ', 'ﾂ': 'ツ', 'ﾃ': 'テ', 'ﾄ': 'ト',
            'ﾅ': 'ナ', 'ﾆ': 'ニ', 'ﾇ': 'ヌ', 'ﾈ': 'ネ', 'ﾉ': 'ノ',
            'ﾊ': 'ハ', 'ﾋ': 'ヒ', 'ﾌ': 'フ', 'ﾍ': 'ヘ', 'ﾎ': 'ホ',
            'ﾏ': 'マ', 'ﾐ': 'ミ', 'ﾑ': 'ム', 'ﾒ': 'メ', 'ﾓ': 'モ',
            'ﾔ': 'ヤ', 'ﾕ': 'ユ', 'ﾖ': 'ヨ',
            'ﾗ': 'ラ', 'ﾘ': 'リ', 'ﾙ': 'ル', 'ﾚ': 'レ', 'ﾛ': 'ロ',
            'ﾜ': 'ワ', 'ｦ': 'ヲ', 'ﾝ': 'ン',
            'ｧ': 'ァ', 'ｨ': 'ィ', 'ｩ': 'ゥ', 'ｪ': 'ェ', 'ｫ': 'ォ',
            'ｯ': 'ッ', 'ｬ': 'ャ', 'ｭ': 'ュ', 'ｮ': 'ョ',
            '｡': '。', '､': '、', 'ｰ': 'ー', '｢': '「', '｣': '」', '･': '・'
          };
          var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
          result = kana.replace(reg, function (match) {
            return kanaMap[match];
          }).replace(/ﾞ/g, '゛').replace(/ﾟ/g, '゜');
          break;
        case "half":
          // 半角に変換する場合
          var kanaMap = {
            "ガ": "ｶﾞ", "ギ": "ｷﾞ", "グ": "ｸﾞ", "ゲ": "ｹﾞ", "ゴ": "ｺﾞ",
            "ザ": "ｻﾞ", "ジ": "ｼﾞ", "ズ": "ｽﾞ", "ゼ": "ｾﾞ", "ゾ": "ｿﾞ",
            "ダ": "ﾀﾞ", "ヂ": "ﾁﾞ", "ヅ": "ﾂﾞ", "デ": "ﾃﾞ", "ド": "ﾄﾞ",
            "バ": "ﾊﾞ", "ビ": "ﾋﾞ", "ブ": "ﾌﾞ", "ベ": "ﾍﾞ", "ボ": "ﾎﾞ",
            "パ": "ﾊﾟ", "ピ": "ﾋﾟ", "プ": "ﾌﾟ", "ペ": "ﾍﾟ", "ポ": "ﾎﾟ",
            "ヴ": "ｳﾞ", "ヷ": "ﾜﾞ", "ヺ": "ｦﾞ",
            "ア": "ｱ", "イ": "ｲ", "ウ": "ｳ", "エ": "ｴ", "オ": "ｵ",
            "カ": "ｶ", "キ": "ｷ", "ク": "ｸ", "ケ": "ｹ", "コ": "ｺ",
            "サ": "ｻ", "シ": "ｼ", "ス": "ｽ", "セ": "ｾ", "ソ": "ｿ",
            "タ": "ﾀ", "チ": "ﾁ", "ツ": "ﾂ", "テ": "ﾃ", "ト": "ﾄ",
            "ナ": "ﾅ", "ニ": "ﾆ", "ヌ": "ﾇ", "ネ": "ﾈ", "ノ": "ﾉ",
            "ハ": "ﾊ", "ヒ": "ﾋ", "フ": "ﾌ", "ヘ": "ﾍ", "ホ": "ﾎ",
            "マ": "ﾏ", "ミ": "ﾐ", "ム": "ﾑ", "メ": "ﾒ", "モ": "ﾓ",
            "ヤ": "ﾔ", "ユ": "ﾕ", "ヨ": "ﾖ",
            "ラ": "ﾗ", "リ": "ﾘ", "ル": "ﾙ", "レ": "ﾚ", "ロ": "ﾛ",
            "ワ": "ﾜ", "ヲ": "ｦ", "ン": "ﾝ",
            "ァ": "ｧ", "ィ": "ｨ", "ゥ": "ｩ", "ェ": "ｪ", "ォ": "ｫ",
            "ッ": "ｯ", "ャ": "ｬ", "ュ": "ｭ", "ョ": "ｮ",
            "。": "｡", "、": "､", "ー": "ｰ", "「": "｢", "」": "｣", "・": "･"
          };
          var reg = new RegExp('(' + Object.keys(kanaMap).join('|') + ')', 'g');
          result = kana.replace(reg, function (match) {
            return kanaMap[match];
          }).replace(/゛/g, 'ﾞ').replace(/゜/g, 'ﾟ');
          break;
        default:
          break;
      }

      return result   
    },

    /////////////////////////////////////
    //
    // 定期消耗品の発送月計算ロジック
    //
    ////////////////////////////////////
    /**
     * 定期消耗品の発送月の算出結果を取得します。(YYYY/MMの文字列)
     */
    getDeliveryMonth: function () {
      var deliveryMonth = this.getDeliveryMonthDate();
      deliveryMonth = this.formatMonth2(deliveryMonth);
      return deliveryMonth;
    },
    /**
     * 1-5⽇はシステム⽇付+1ヶ月の初日、6⽇以降はシステム⽇付+2ヶ月の初日を取得します。(Dateオブジェクト)
     */
    getDeliveryMonthDate: function () {
      var now = new Date();
      var today = now.getDate();
      var addMonth = 0;
      if (today < 6) {
        addMonth = 1;
      } else {
        addMonth = 2;
      }
      var deliveryMonthDate = new Date(now.getFullYear(), now.getMonth() + addMonth, 1);
      return deliveryMonthDate;
    },
    /////////////////////////////////////
    //
    // 文字列中の空白文字削除関数
    //
    ////////////////////////////////////
    /**
     * 品目コード、シリアルナンバーの空白文字削除
     */
    spaceDelete: function (value) {
      value = value.replace(/\s+/g, "");
      return value;
    },

    // サブシステム、環境ごとの背景色追加
    addSubSystemStyleBackColor(style) {
      const backgroundColor = store.state.subSystem.backgroundColor[store.state.env];
      if (style) {
        return style + "background-color:" + backgroundColor + ";";
      } else {
        return {
          "background-color": backgroundColor
        };
      }
    },

    // サブシステム、環境ごとの背景色追加
    addSubSystemStyleBackColorOpacity(style, opacity) {
      let _style = this.addSubSystemStyleBackColor(style);
      if (opacity && typeof _style == "string") {
        _style += "opacity: " + opacity + ";";
      } else {
        _style["opacity"] = opacity;
      }
      return _style;
    },

    // サブシステム、環境ごとの背景色追加
    getSubSystemClass() {
      return store.state.subSystem.class[store.state.env];
    },

    getSubSystemColor(keyName) {
      return subSystem.SUB_SYSTEMS[keyName].backgroundColor[store.state.env];
    },

    getShoumouCancelRangeEndDay() {
      let rangeEndDate = dayjs();
      rangeEndDate = rangeEndDate.endOf("month");
      rangeEndDate = rangeEndDate.subtract(9, "day");
      const rengeEndDay = rangeEndDate.date();
    
      return rengeEndDay;   
    } ,   
  }
}




// WEBPACK FOOTER //
// ./src/mixin.js